import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { RestaurantDetailSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-section'
import { RestaurantDetailSectionId } from '@/features/restaurants/restaurant-detail/utils/restaurant-detail-helpers'
import { RestaurantRewardCard } from '@/features/restaurants/restaurant-reward-card'
import { cn } from '@/utils/styles/cn'

export function RestaurantDetailRewards() {
    const { restaurant } = useRestaurantDetailContext()

    const rewards = restaurant?.loyalty?.rewards

    if (!rewards?.length) return null

    return (
        <RestaurantDetailSection
            id={RestaurantDetailSectionId.REWARDS}
            title="restaurants.detail.rewards.title"
        >
            <div
                className={cn(
                    'grid grid-cols-1 gap-4',
                    rewards.length > 2 ? 'md:grid-cols-2 lg:grid-cols-3' : 'md:grid-cols-2'
                )}
            >
                {rewards?.map((reward) => {
                    return (
                        <RestaurantRewardCard
                            key={'restaurant-detail-content' + reward.uuid}
                            reward={reward}
                        />
                    )
                })}
            </div>
        </RestaurantDetailSection>
    )
}
